export type PublishFileSelectionResult = {
  file: File | null;
  error?: string;
};

export function applyValidatedFileSelection(
  file: File | null,
  validate: (candidate: File | null) => string | null,
): PublishFileSelectionResult {
  if (!file) {
    return { file: null };
  }

  const error = validate(file);
  if (error) {
    return { file: null, error };
  }

  return { file };
}

export const PUBLISH_APK_ACCEPT =
  ".apk,application/vnd.android.package-archive,application/octet-stream";
export const PUBLISH_IMAGE_ACCEPT = ".png,.jpg,.jpeg,image/png,image/jpeg";

export const uploadPreviewImageStyle = {
  position: "absolute" as const,
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover" as const,
  display: "block",
};
